import {RadioField} from '@/components/commons/radio-field/RadioField'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import {ChangeEventHandler} from 'react'
import {FieldError} from 'react-hook-form'

interface LocalAuthorityAssistanceServiceRadioButtonsProps {
    name: string
    value: 'provided' | 'notProvided'
    label: string
    onChange: ChangeEventHandler<HTMLInputElement>
    error?: FieldError
}

export const LocalAuthorityAssistanceServiceRadioButtons = ({
    name,
    value,
    label,
    onChange,
    error
}: LocalAuthorityAssistanceServiceRadioButtonsProps) => {
    const {t} = useTranslation()
    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{label}</Label>
            <Flexbox fullWidth direction="column" gap={1.5}>
                <Grid columns={2} gap={4} fullWidth>
                    <FormFieldBox spanColumn={1} isSelected={value == 'provided'} hasError={!!error}>
                        <RadioField
                            label={t('patients:provided')}
                            name={name}
                            checked={value == 'provided'}
                            onChange={onChange}
                            value="provided"
                        />
                    </FormFieldBox>
                    <FormFieldBox spanColumn={1} isSelected={value == 'notProvided'} hasError={!!error}>
                        <RadioField
                            label={t('patients:not_provided')}
                            name={name}
                            checked={value == 'notProvided'}
                            onChange={onChange}
                            value="notProvided"
                        />
                    </FormFieldBox>
                </Grid>
                {error?.message && <InputHelpText error={error.message} />}
            </Flexbox>
        </Flexbox>
    )
}
